/*
 * @Description: 基础的按钮组件
 * @Author: kadenwang@tencent.com
 * @Date: 2021-11-18 17:13:01
 * @LastEditors: kadenwang@tencent.com
 * @LastEditTime: 2021-12-14 15:08:07
 */

import classNames from 'classnames';
import i18n from '../../i18n';

import './index.less';

export interface IButton {
  disable: boolean;
  onClick: () => void;
}

export const Button = (props: IButton) => {
  const { disable, onClick } = props;

  return (
    <div className={classNames('login-v2-base-button', { disable })} onClick={disable ? () => {} : onClick}>
      {i18n.l('Confirm')}
    </div>
  );
};
